import { vestResolver } from "@hookform/resolvers/vest";
import { Component, FC, useEffect, useRef, useState } from "react";
import { set, useForm, useFormState, useWatch, Controller } from "react-hook-form";
import { isRegularExpressionLiteral } from "typescript";
import { UseSalarySimContext } from "../Context/SalarySimContext";
import { getInputCssClass } from "../FormModel/FormStyleHelper";
import { FormSuite } from "../FormModel/FormValidator_Simple_Ecran1";
import InputData from "../Model/InputData";
import { SalSimFormProps } from "../FormModel/FormStepProps";
import { UseCodeListContext } from "../Context/CodeListContext";
import { AllowedMonthPeriod, GetAllowedPeriods } from "../FormModel/FormHelper";

import '../css/normalize.css';
import '../css/webflow.css';
import '../css/salarysimwebflow.css';
import '../css/salarysimwebflow_custom.css';
import '../css/salarysim.css';
import { UseTranslationContext } from "../Context/TranslationContext";

import LocalizedDatePicker from "./LocalizedDatePicker";
import dayjs, { Dayjs } from "dayjs";
import MUITooltipCustom from "./MUITooltipCustom";

import parse from 'html-react-parser';
import { DateTime } from "luxon";

import utc from 'dayjs/plugin/utc';
import PrestaComponent from "./PrestaComponent";
import { UseConfigContext } from "../Context/ConfigContext";
import { Checkbox } from "@mui/material";
import PreviousSimulationComponent from "./PreviousSimulationComponent";
dayjs.extend(utc);


const Step1Simple:FC<SalSimFormProps> = (props) => {
    const{currentLanguage, getKeyFromKeyId} = UseTranslationContext();
    const {codeListForm, getCodeListKey} = UseCodeListContext();
    const {checkInternalVersion} = UseConfigContext();

    const{salarySimFormData, salarySimAdvancedFormData, isSimpleSimulationMode, updateSalarySimData } = UseSalarySimContext();
    const [monthlyPeriodsSelect, setMonthlyPeriodsSelect] = useState(new Array<AllowedMonthPeriod>());

    const [datePickerDefaultValue, setDatePickerDefaultValue] = useState<Dayjs>(dayjs("1/1/1980"));
   
    const {register, handleSubmit, setValue, trigger, formState: {errors}, control} = useForm({
        resolver:vestResolver(FormSuite),
        mode:'onChange',
        reValidateMode: 'onChange',
        context: undefined,
        criteriaMode: "firstError",
        shouldFocusError: false,
        shouldUnregister: false,
        delayError: undefined,
    });


    useEffect(()=>{
        if(codeListForm != null && codeListForm.clLocalUnit != null && codeListForm.clLocalUnit.length>0)
        {
          setValue('selectedUniteEtablissement',codeListForm.clLocalUnit[0].keyValNum);
        }
    },[codeListForm]);



    useEffect(() => {

      var months=GetAllowedPeriods(currentLanguage);
      setMonthlyPeriodsSelect(months);

        //init default
        setValue('selectedEtatCivil',1);
        setValue('selectedConjoint',0);
        setValue('selectedPeriode',months[0].monthValue.toString());

        UpdateDateOfBirth(datePickerDefaultValue);
      }, []);
      

      useEffect(() => {
        setMonthlyPeriodsSelect(GetAllowedPeriods(currentLanguage));
      }, [currentLanguage]);

      useEffect(() => {
        if(isSimpleSimulationMode == false && salarySimAdvancedFormData != null)
        {
          if(salarySimAdvancedFormData.loadFromPresta == true)
          {
            setValue("UserName",salarySimAdvancedFormData.UserName);

            if(monthlyPeriodsSelect.some((x) => x.monthValue == salarySimAdvancedFormData.Period)){
              setValue("selectedPeriode",salarySimAdvancedFormData.Period);
            }
            
            //correction suite au non mapping de l'unité d'etablissement pour le chargement des vieilles simulation
            //var valNumOfUnit = codeListForm.clLocalUnit.find(x => x.keyValString == salarySimAdvancedFormData.EstablishmentUnit)?.keyValNum;
            var valNumOfUnit = codeListForm.clLocalUnit.find(x => x.keyValNum.toString() == salarySimAdvancedFormData.EstablishmentUnit)?.keyValNum;
            if(valNumOfUnit == undefined)
            {
              valNumOfUnit = codeListForm.clLocalUnit.find(x => x.keyValString == salarySimAdvancedFormData.EstablishmentUnit)?.keyValNum;
            }

            //var valNumOfUnit = codeListForm.clLocalUnit.find(x => x.keyValString == 'test')?.keyValNum;
            setValue("selectedUniteEtablissement",valNumOfUnit != undefined?valNumOfUnit:8888888275);

            setValue("HiringType",salarySimAdvancedFormData.HiringType);
            setValue("selectedEtatCivil",salarySimAdvancedFormData.MaritalStatus);
            setValue("selectedConjoint",salarySimAdvancedFormData.Spouse);
            setValue("disabledCheckbox",salarySimAdvancedFormData.Disabled);
            setValue("disabledSpouseCheckbox",salarySimAdvancedFormData.DisabledSpouse);

            //UpdateDateOfBirth(dayjs(salarySimAdvancedFormData.BirthDate))
            var dayjsDate = dayjs(salarySimAdvancedFormData.BirthDate, 'YYYY/MM/DD');
            setDatePickerDefaultValue(dayjsDate);

            setValue("dependentsCheckbox",salarySimAdvancedFormData.Dependant);
            setValue("depChildren",salarySimAdvancedFormData.DependantChildren);
            setValue("depChildrenDis",salarySimAdvancedFormData.DisabledDependantChildren);

            setValue("depOthers",salarySimAdvancedFormData.OthersDependant);
            setValue("depOthersDis",salarySimAdvancedFormData.OthersDisabledDependant);

            setValue("dep65Transition",salarySimAdvancedFormData.More65TransitionalMeasureDependant);
            setValue("dep65TransitionDis",salarySimAdvancedFormData.More65TransitionalMeasureDisabledDependant);

            setValue("dep65Dependent",salarySimAdvancedFormData.More65DependanceSituationDependant);
            //setValue("dep65DependentDis",salarySimAdvancedFormData.More65DependanceSituationDisabledDependant);

            props.formPrestaLoaded(1);
          }
        }

      }, [salarySimAdvancedFormData]);

      const formDependentsCheck = useWatch({ control, name: "dependentsCheckbox", defaultValue: (salarySimFormData.Dependant != undefined)?salarySimFormData.Dependant:false});
      const formShowSpouse = useWatch({ control, name: "selectedEtatCivil", defaultValue: (salarySimFormData.MaritalStatus != undefined)?salarySimFormData.MaritalStatus:0});

      useEffect(() => {
        if(formDependentsCheck == false)
        {
            setValue('depChildren', 0);
            setValue('depChildrenDis', 0);
            setValue('depOthers', 0);
            setValue('depOthersDis', 0);
            setValue('dep65Transition', 0);
            setValue('dep65TransitionDis', 0);
            setValue('dep65Dependent', 0);
            //setValue('dep65DependentDis', 0);
        }
      }, [formDependentsCheck]);

    const formRef = useRef<HTMLFormElement>(null);
    useEffect(() => {
      if (props.requestFormValidation != null && props.requestFormValidation.includes(props.formStep) && formRef.current) {
        formRef.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      }
    },[props.requestFormValidation])

    const SendSalarySimForm=(data:any) => {
        //Validation OK

        let step1Data : InputData = new InputData();

        step1Data.UserName = data?.UserName;
        step1Data.Period = data?.selectedPeriode;
        step1Data.EstablishmentUnit = data?.selectedUniteEtablissement;

        var correspondingUnit = codeListForm.clLocalUnit.find(x => x.keyValNum.toString() == step1Data.EstablishmentUnit);
        step1Data.HomeRegionCode = correspondingUnit?correspondingUnit.keyValString:"";

        step1Data.HiringType = parseInt(data?.HiringType, 10);
        step1Data.MaritalStatus=parseInt(data?.selectedEtatCivil,10);
        step1Data.Spouse=data?.selectedConjoint;
        step1Data.Disabled=data?.disabledCheckbox;
        step1Data.DisabledSpouse=(data?.disabledSpouseCheckbox != undefined)?data?.disabledSpouseCheckbox:false;

        var birthdate = data?.BirthDate as Dayjs;
        step1Data.BirthDate=birthdate.utc(true).toString();

        // dependents
        step1Data.Dependant = data?.dependentsCheckbox;

        step1Data.DependantChildren=parseInt(data?.depChildren);
        step1Data.DisabledDependantChildren=parseInt(data?.depChildrenDis);

        step1Data.OthersDependant=parseInt(data?.depOthers);
        step1Data.OthersDisabledDependant=parseInt(data?.depOthersDis);

        
        step1Data.More65TransitionalMeasureDependant=parseInt(data?.dep65Transition);
        step1Data.More65TransitionalMeasureDisabledDependant=parseInt(data?.dep65TransitionDis);

        step1Data.More65DependanceSituationDependant=parseInt(data?.dep65Dependent);
        //step1Data.More65DependanceSituationDisabledDependant=parseInt(data?.dep65DependentDis);


        if(updateSalarySimData != undefined)
        {
           updateSalarySimData(step1Data, 1, isSimpleSimulationMode);
        }

        //props.changeStep(true);
        props.formValidationCallback(props.formStep, true);
     }

     const onFormError = (formErrors : any, e : any) =>{
       props.formValidationCallback(props.formStep, false);
     }

     const UpdateDateOfBirth=(mydate:Dayjs)=>{
        setValue('BirthDate', mydate, { shouldValidate: true, shouldDirty: true});
     };

     const UpdateDependentValues = (e: any) => {
      //trigger(["depChildrenDis","depOthersDis", "dep65TransitionDis", "dep65DependentDis"]);
      trigger(["depChildrenDis","depOthersDis", "dep65TransitionDis"]);
     }

     const GetInputFieldCssClass = (inError: boolean) => {
       return ( inError?'number-field w-input inputFieldError inputFixedMaxHeight':'number-field w-input inputFixedMaxHeight' );
     }

    return(
        <>

        <div style={{display:(props.isCurrentForm?'':'none')}}>
        
        { !isSimpleSimulationMode && checkInternalVersion() && 
          <>
          <div className="group-field-load">
            <PreviousSimulationComponent></PreviousSimulationComponent>
            <PrestaComponent></PrestaComponent>
          </div>
          
          </>
        }

        <form ref={formRef} id="formStep1" onSubmit={handleSubmit((d) => SendSalarySimForm(d), (data, e) => onFormError(data,e))} name="wf-form-Etape1-simplifi" data-name="Etape1-simplifié" method="post" aria-label={getKeyFromKeyId("SECTION_WORKER_DATA")} className={isSimpleSimulationMode?"form-step formIndex formSize":(checkInternalVersion()?"form-step1-avance formIndex formSizeAdv":"form-step1-avance form-step1-avance-external formIndex formSizeAdv")}>

        { !isSimpleSimulationMode &&
        <div id="group-field-name" className="group-field">
            <div className="group-label"><label aria-hidden="true" htmlFor="name" className="field-label">{getKeyFromKeyId("NOM")}</label></div>
            <div className="text-field-icon">
              <input type="text" {...register("UserName")} className="text-field w-input" maxLength={256} placeholder={getKeyFromKeyId("NOM")} id="name" />
              {errors?.UserName && <p className='inputErrorHelper'>{errors.UserName.message as any}</p>}
              </div>
          </div>
        }
          <div id="group-field-periode" className="group-field">
            <label aria-hidden="true" htmlFor="periode" className="field-label">{getKeyFromKeyId("PERIODE")}</label>
            <div className="text-field-icon">
            <select {...register('selectedPeriode')} className="select-field w-select inputFixedMaxHeight">
              {monthlyPeriodsSelect.map((item, i) =>
                        <option key={"month" + i} value={item.monthValue}>{item.monthName}</option> 
              )}
              </select>
              {errors?.selectedPeriode && <p className='inputErrorHelper'>{errors.selectedPeriode.message as any}</p>}
              </div>
          </div>
          <div id="group-field-etat-civil" className="group-field">
            <label aria-hidden="true" htmlFor="etat-civil" className="field-label">{getKeyFromKeyId("ETAT_CIVIL")}</label>
            <div className="text-field-icon">
              <select {...register('selectedEtatCivil')} className="select-field w-select inputFixedMaxHeight">
              {codeListForm.clMaritalStatus.map((item) =>
                        <option key={item.keyId + item.keyValNum} value={item.keyValNum}>{getCodeListKey(item.keyId, item.keyValNum)}</option> 
                    )}
              </select>
              </div>
          </div>
          <div id="group-field-uniteetablissement" className="group-field">
              <label aria-hidden="true" htmlFor="unite-etablissement" className="field-label">{getKeyFromKeyId("UNITE_ETABLISSEMENT")}</label>
                <div className="text-field-icon">
                <select {...register('selectedUniteEtablissement')} className="select-field w-select inputFixedMaxHeight">
                    {codeListForm.clLocalUnit.map((item) =>
                        <option key={item.keyId + item.keyValNum} value={item.keyValNum}>{getCodeListKey(item.keyId, item.keyValNum)}</option> 
                    )}
              </select>
              </div>
          </div>

          { !isSimpleSimulationMode &&
          <div className="group-field">
            <label htmlFor="type-engagement" aria-hidden="true" className="field-label">{getKeyFromKeyId("APPOINTMENT_TYPE")}</label>
            <div className="text-field-icon">
              <select {...register('HiringType')} className="select-field w-select inputFixedMaxHeight">
                { codeListForm.clCdHire.map((element,i) => 
                                
                  <option key={element.keyId + element.keyValNum} value={element.keyValNum}>{`${i>0?getKeyFromKeyId("REDUCTION"):''} ${getCodeListKey(element.keyId, element.keyValNum)}`}</option>
                  
                )}
              </select></div>
          </div>
          }

          <div id="group-field-naissance" className="group-field">
            <div className="group-label">
              <label aria-hidden="true" htmlFor="date-de-naissance" className="field-label-icon">{`${getKeyFromKeyId("BIRTHDATE")} (${getKeyFromKeyId("MANDATORY_FIELD")})`}</label>
            </div>
            <div className="text-field-icon">
                <LocalizedDatePicker startDate={datePickerDefaultValue} updateDate={ (myDate:Dayjs)=>UpdateDateOfBirth(myDate)} />
            </div>
            {errors?.BirthDate && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.BirthDate.message as any)}</p>}  
          </div>

          <label id="w-node-_47d3e4d7-0668-5bf9-cb83-52f65375aae5-1b011521" className="w-checkbox checkbox-field" htmlFor="disabledCheckbox">
          <Controller
            name="disabledCheckbox"
            control={control}
            defaultValue={false}
            render={({ field: { value, ref, ...field } }) => (
            <Checkbox size="medium" id="disabledCheckbox" data-name="falseHybrid" aria-label={getKeyFromKeyId("DISABLED_PERSON")}
              {...field}
              checked={!!value}
              sx={{
              color: '#90BBB5',
              '&.Mui-checked': {
              color: '#90BBB5',
            }
            }} />
            )}
          />
              
          <span aria-hidden="true" className="checkbox-label-2 w-form-label" >{getKeyFromKeyId("DISABLED_PERSON")}</span>
          </label>

          { ( formShowSpouse == 2 || formShowSpouse == 6 ) &&
          <>
          <div className="group-field">
            <label aria-hidden="true" htmlFor="conjoint" className="field-label">{getKeyFromKeyId("CONJOINT")}</label>
            <div className="text-field-icon">
                <select {...register('selectedConjoint')} className="select-field w-select">
                    {codeListForm.clPartner.map((item) =>
                        <option key={item.keyId + item.keyValNum} value={item.keyValNum}>{getCodeListKey(item.keyId, item.keyValNum)}</option> 
                    )}
              </select>
            </div>
          </div>

        <label className="w-checkbox checkbox-field alignLeft" htmlFor="disabledSpouseCheckbox">
        <Controller
            name="disabledSpouseCheckbox"
            control={control}
            defaultValue={false}
            render={({ field: { value, ref, ...field } }) => (
            <Checkbox size="medium" id="disabledSpouseCheckbox" aria-label={getKeyFromKeyId("SPOUSE_DISABLED66")}
            {...field}
              checked={!!value}
            sx={{
            color: '#90BBB5',
              '&.Mui-checked': {
              color: '#90BBB5',
            }
          }} />
          )}
          />
              <span aria-hidden="true" className="checkbox-label-2 w-form-label" >{getKeyFromKeyId("SPOUSE_DISABLED66")}</span>
              <MUITooltipCustom tooltipText={parse(getKeyFromKeyId("TOOLTIP_HELP_SPOUSE"))} buttonAltText={getKeyFromKeyId("TOOLTIP_HELP_ALT_PARTNER")} placement="top"/>
          </label>
        </>
        }

          <div tabIndex={0} role="checkbox" aria-checked={formDependentsCheck} id="w-node-bb0f05d9-8490-1236-d704-2135439a38b2-1b011521" className="group-toggle left">
            <p id="w-node-_3157d34d-ba1f-1a2c-aa25-2646358cacf5-1b011521" className="label-toggle">{getKeyFromKeyId("PERSONNE_CHARGES")}</p>
            <div id="toggle-container" className="toggle-container">
              <div onClick={() => setValue("dependentsCheckbox", !formDependentsCheck )} className={formDependentsCheck?"toggle-appearance":"toggle-appearance off disable grey"}>
                <div className="toggle"></div>
              </div>
              <label className="w-checkbox checkbox-disable" htmlFor="checkboxDependents">
                <input {...register("dependentsCheckbox")} type="checkbox" id="checkboxDependents"  className="w-checkbox-input checkbox-2" />
                <span className={formDependentsCheck?"text-toggle actif w-form-label":"text-toggle w-form-label"} >{(formDependentsCheck ? getKeyFromKeyId("OUI") : getKeyFromKeyId("NON"))}</span>
              </label>
            </div>
          </div>


          {formDependentsCheck && 
        <div id="section-charge" aria-label={getKeyFromKeyId("ACCESS_INFO_DEPENDENTS")} className="group-toggle-actif w-node-f95f6996-6d54-a590-41e1-67e1c72aa110-416cf1c7">
          <div id="group-field-enfants" className="group-field w-node-_1a0d8097-b4f4-2bf6-3587-6779cb2bb05b-416cf1c7">
            <div className="group-label">
                  <label aria-hidden="true" htmlFor="enfants" className="field-label-icon">{getKeyFromKeyId("CHILDREN")} :</label>
                  <MUITooltipCustom tooltipText={parse(getKeyFromKeyId("TOOLTIP_HELP_DEPENDENT"))} buttonAltText={getKeyFromKeyId("TOOLTIP_HELP_ALT_DEPENDENTS")} placement="top"/>
            </div>
              <div className="flex-horizontal">
                  <input type="number" className={GetInputFieldCssClass(errors?.depChildren?true:false)} maxLength={256} {...register('depChildren', { onChange: (e) => UpdateDependentValues(e) }) } id="enfants"/>
                <div>{getKeyFromKeyId("LABEL_DEPENDENT_PREP")}</div>
                <input type="number" className={GetInputFieldCssClass(errors?.depChildrenDis?true:false)} maxLength={256} {...register("depChildrenDis")}  aria-label={getKeyFromKeyId("ACCESS_CHILDREN_DISABLED")} id="enfants-2"/>
                <div aria-hidden="true">{getKeyFromKeyId("LABEL_HANDICAPPED")}</div>
              </div>
                {errors?.depChildren && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.depChildren.message as any)}</p>}
                {errors?.depChildrenDis && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.depChildrenDis.message as any)}</p>}
            </div>

            <div id="w-node-_7e611548-50ac-ceb5-1de0-e381ffab2831-416cf1c7" className="group-field">
              <div className="group-label">
                  <label aria-hidden="true" htmlFor="autres" className="field-label">{getKeyFromKeyId("DEPENDENT_SUB65")} :</label>
                </div>
              <div className="flex-horizontal">
                  <input type="number" className={GetInputFieldCssClass(errors?.depOthers?true:false)} maxLength={256} {...register("depOthers", { onChange: (e) => UpdateDependentValues(e) })} id="autres"/>
                <div>{getKeyFromKeyId("LABEL_DEPENDENT_PREP")}</div>
                <input type="number" className={GetInputFieldCssClass(errors?.depOthersDis?true:false)} maxLength={256} {...register("depOthersDis")} aria-label={getKeyFromKeyId("ACCESS_OTHERS_DISABLED")}  id="autres-2"/>
                <div aria-hidden="true">{getKeyFromKeyId("LABEL_HANDICAPPED_F")}</div>
              </div>
                {errors?.depOthers && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.depOthers.message as any)}</p>}
                {errors?.depOthersDis && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.depOthersDis.message as any)}</p>}
            </div>
            <div id="w-node-f98ff7a6-8ee9-e31f-d578-a0d244923c49-416cf1c7" className="group-field">
              <div className="group-label">
                  <label aria-hidden="true" htmlFor="transitoire" className="field-label">{getKeyFromKeyId("DEPENDENT_PAST65")} :</label></div>
              <div className="flex-horizontal">
                  <input type="number" className={GetInputFieldCssClass(errors?.dep65Transition?true:false)} maxLength={256} {...register("dep65Transition", { onChange: (e) => UpdateDependentValues(e) })} id="transitoire"/>
                <div>{getKeyFromKeyId("LABEL_DEPENDENT_PREP")}</div>
                <input type="number" className={GetInputFieldCssClass(errors?.dep65TransitionDis?true:false)} maxLength={256} {...register("dep65TransitionDis")} aria-label={getKeyFromKeyId("ACCESS_65+_DISABLED")} id="transitoire-2"/>
                <div aria-hidden="true">{getKeyFromKeyId("LABEL_HANDICAPPED_F")}</div>
              </div>
              {errors?.dep65Transition && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.dep65Transition.message as any)}</p>}
                {errors?.dep65TransitionDis && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.dep65TransitionDis.message as any)}</p>}
            </div>
            <div id="group-field-dependance" className="group-field w-node-bd0730a2-fa3e-4b03-8237-97002828caa5-416cf1c7">
              <div className="group-label">
                  <label aria-hidden="true" htmlFor="d-pendance" className="field-label">{getKeyFromKeyId("DEPENDENT_PAST65_DEPENDENCY")} :</label></div>
              <div className="flex-horizontal">
                  <input type="number" className={GetInputFieldCssClass(errors?.dep65Dependent?true:false)} maxLength={256} {...register("dep65Dependent", { onChange: (e) => UpdateDependentValues(e) })} id="d-pendance"/>
                {/* 
                <div>{getKeyFromKeyId("LABEL_DEPENDENT_PREP")}</div>
                <input type="number" className={GetInputFieldCssClass(errors?.dep65DependentDis?true:false)} maxLength={256} {...register("dep65DependentDis")} aria-label={getKeyFromKeyId("ACCESS_DEPENDENCY_DISABLED")} id="d-pendance-2"/>
                <div aria-hidden="true">{getKeyFromKeyId("LABEL_HANDICAPPED_F")}</div>
                {errors?.dep65DependentDis && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.dep65DependentDis.message as any)}</p>}
                */}
              </div>
                
              {errors?.dep65Dependent && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.dep65Dependent.message as any)}</p>}
                
            </div>
          </div>
        }
        </form>
        </div>
        </>
       
       );

}

export default Step1Simple;